module.exports = {"id":"s2-q2","text":"Have you participated in online training in the past 5 years?","multiselect":false,"options":[{"id":"s2-q2-a1","text":"Yes","baseline":3,"focusAreaBaseline":4,"next":"s2-q2a","capability":3,"access":2,"focusarea":[3,0,0,3,0]},{"id":"s2-q2-a2","text":"No","next":"s3-q1","capability":-2,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q2.json
// module id = 894
// module chunks = 41